import apiRequest from "../../helpers/apiRequest";

export default async (id) => {
    return await apiRequest({
        method: 'delete',
        url: `studies/studymodules/content-creator/${id}/`,
    })
}
